/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlateformeThemeDto
 */
export interface PlateformeThemeDto {
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    plateformeId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    logoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    minimalLogoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    logoFileId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    minimalLogoFileId?: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    primaryColor: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    secondaryColor: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    backgroundColor: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    surfaceColor: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    accentColor: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    errorColor: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    successColor: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    warningColor: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    infoColor: string;
    /**
     * 
     * @type {string}
     * @memberof PlateformeThemeDto
     */
    fontFamily: string;
}

/**
 * Check if a given object implements the PlateformeThemeDto interface.
 */
export function instanceOfPlateformeThemeDto(value: object): value is PlateformeThemeDto {
    if (!('primaryColor' in value) || value['primaryColor'] === undefined) return false;
    if (!('secondaryColor' in value) || value['secondaryColor'] === undefined) return false;
    if (!('backgroundColor' in value) || value['backgroundColor'] === undefined) return false;
    if (!('surfaceColor' in value) || value['surfaceColor'] === undefined) return false;
    if (!('accentColor' in value) || value['accentColor'] === undefined) return false;
    if (!('errorColor' in value) || value['errorColor'] === undefined) return false;
    if (!('successColor' in value) || value['successColor'] === undefined) return false;
    if (!('warningColor' in value) || value['warningColor'] === undefined) return false;
    if (!('infoColor' in value) || value['infoColor'] === undefined) return false;
    if (!('fontFamily' in value) || value['fontFamily'] === undefined) return false;
    return true;
}

export function PlateformeThemeDtoFromJSON(json: any): PlateformeThemeDto {
    return PlateformeThemeDtoFromJSONTyped(json, false);
}

export function PlateformeThemeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlateformeThemeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'plateformeId': json['plateformeId'] == null ? undefined : json['plateformeId'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'minimalLogoUrl': json['minimalLogoUrl'] == null ? undefined : json['minimalLogoUrl'],
        'logoFileId': json['logoFileId'] == null ? undefined : json['logoFileId'],
        'minimalLogoFileId': json['minimalLogoFileId'] == null ? undefined : json['minimalLogoFileId'],
        'primaryColor': json['primaryColor'],
        'secondaryColor': json['secondaryColor'],
        'backgroundColor': json['backgroundColor'],
        'surfaceColor': json['surfaceColor'],
        'accentColor': json['accentColor'],
        'errorColor': json['errorColor'],
        'successColor': json['successColor'],
        'warningColor': json['warningColor'],
        'infoColor': json['infoColor'],
        'fontFamily': json['fontFamily'],
    };
}

export function PlateformeThemeDtoToJSON(json: any): PlateformeThemeDto {
    return PlateformeThemeDtoToJSONTyped(json, false);
}

export function PlateformeThemeDtoToJSONTyped(value?: PlateformeThemeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'plateformeId': value['plateformeId'],
        'logoUrl': value['logoUrl'],
        'minimalLogoUrl': value['minimalLogoUrl'],
        'logoFileId': value['logoFileId'],
        'minimalLogoFileId': value['minimalLogoFileId'],
        'primaryColor': value['primaryColor'],
        'secondaryColor': value['secondaryColor'],
        'backgroundColor': value['backgroundColor'],
        'surfaceColor': value['surfaceColor'],
        'accentColor': value['accentColor'],
        'errorColor': value['errorColor'],
        'successColor': value['successColor'],
        'warningColor': value['warningColor'],
        'infoColor': value['infoColor'],
        'fontFamily': value['fontFamily'],
    };
}

